import { Event } from '@nostr/tools/wasm'
import { toNote } from '@/lib/link'
import Content from './Content'

export default function NormalContentPreview({
  event,
  className
}: {
  event: Event
  className?: string
}) {
  return (
    <a
      href={toNote(event)}
      onClick={(e) => e.preventDefault()}
      className={className}
      title={event.content}
    >
      <Content event={event} />
    </a>
  )
}
